import { createWithEqualityFn } from 'zustand/traditional'
// import axios from 'axios'
// import { Cookies } from 'react-cookie'

// const accessToken = new Cookies().get('kumopack-buyer-access-token')
// const CHAT_API_ENDPOINT = process.env.REACT_APP_CHAT_API_URL

interface ChatStore {
	unreadData: any
	setUnreadData: (unreadData: any) => void
	getUnreadData: () => Promise<{ success: boolean; data: any }>
}

export const useChatStore = createWithEqualityFn<ChatStore>(
	set => ({
		unreadData: {},
		setUnreadData: (unreadData: any) => {
			set({ unreadData })
		},
		getUnreadData: async () => {
			return { success: true, data: 'chat' }
			// return axios
			// 	.get(`${CHAT_API_ENDPOINT}/supplier-unread`, {
			// 		headers: {
			// 			Authorization: `Bearer ${accessToken}`,
			// 		},
			// 	})
			// 	.then(res => {
			// 		set({ unreadData: res.data })

			// 		return { success: true, data: res.data }
			// 	})
			// 	.catch(err => {
			// 		return {
			// 			success: false,
			// 			data: err?.response?.data?.message?.toString() ?? 'Something went wrong.',
			// 		}
			// 	})
		},
	}),
	Object.is
)
